<template>
    <div>
        <div class="row spacing_top">
            <div class="form-group col-sm-6 col-xs-12">
                <label><input type='checkbox' v-model='state.object.data.accessory_metadata.current' :true-value=1 :false-value=0 @click='saveRevision'>  Mark as Current</label>
            </div>
        </div>
        <div class="row spacing_top">
            <div class="form-group col-sm-6 col-xs-12">
                <label>Other Revisions</label>
                <div v-for="revision in revisions"  :key="revision.economizer_id" class="assetImage">
                    <router-link :to="`/curb/${revision.curb_id}`">{{ revision.nomenclature }}</router-link>
                    Revision: {{ revision.revision }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { store } from '@/store/BusinessObject.store.js'
import helpers from "@/store/helpers";
export default {
    name: 'Revisions',
    data() {
        return {
            state: store.state,
            revisions: store.state.object.data.accessory_metadata.revisions,
            forms: {
                revisionForm: {
                    accessory_type_id: {val: 0, qsField:'[accessory_type_id]'},
                    current: {val: 0, qsField: '[current]'},
                    curbID: { val: '', qsField: '[curb_id]' },
                    cdi_part_id_new: { val: '', qsField: '[cdi_part_id_new]'},
                    product_type_id: { val: '', qsField: '[product_type_id]'},
                    orientation_id: { val: '', qsField: '[orientation_id]'},
                    control_id: { val: '', qsField: '[control_id]'},
                    actuator_id: { val: '', qsField: '[actuator_id]'},
                    sensor_id: { val: '', qsField: '[sensor_id]'},
                    economizer_id: { val: '', qsField: '[economizer_id]'},
                }
            }
        }
    },
    methods: {
        saveRevision: function () {
            this.forms.revisionForm.current.val = (this.state.object.data.accessory_metadata.current) ? 0 : 1;
            this.forms.revisionForm.accessory_type_id.val = (this.state.object.data.accessory_type_id);
            this.forms.revisionForm.curbID.val = (this.state.object.data.curb_id);
            this.forms.revisionForm.cdi_part_id_new.val = (this.state.object.data.accessory_metadata.cdi_part_id_new);
            this.forms.revisionForm.product_type_id.val = (this.state.object.data.accessory_metadata.product_type_id);
            this.forms.revisionForm.orientation_id.val = (this.state.object.data.accessory_metadata.orientation_id);
            this.forms.revisionForm.control_id.val = (this.state.object.data.accessory_metadata.control_id);
            this.forms.revisionForm.actuator_id.val = (this.state.object.data.accessory_metadata.actuator_id);
            this.forms.revisionForm.sensor_id.val = (this.state.object.data.accessory_metadata.sensor_id);
            this.forms.revisionForm.economizer_id.val = (this.state.object.data.accessory_metadata.economizer_id);
            store.apiWithObjectLoad('update_accessory', helpers.getQSPairs(this.forms.revisionForm));
        },
    }
}
</script>